<template>
  <div class="widget-details">
    <div class="block">
      <div class="block-header">
        <h4 class="block-title">{{ title }}</h4>
        <div
          v-on-clickaway="handleBodyClick"
          class="more-options-wrapper"
          @click="handleShowOptionsClick"
        >
          <img
            v-if="actionButtons.length"
            src="~@/assets/media/icons/more_options.svg"
            alt="more options icon"
          />
          <div class="options" :class="{ 'is-visible': isVisible }">
            <ul v-if="actionButtons.length != 0">
              <li
                v-for="(option, i) in actionButtons"
                :key="i"
                @click="customMethod(option, i)"
              >
                <a>
                  <img
                    v-if="option.icon === 'edit'"
                    src="~@/assets/media/icons/create.svg"
                    alt="create icon"
                  />
                  <img
                    v-if="option.icon === 'deactivate'"
                    src="~@/assets/media/icons/remove.svg"
                    alt="remove icon"
                  />
                  <img
                    v-if="option.icon === 'activate'"
                    src="~@/assets/media/icons/visibility.svg"
                    alt="remove icon"
                  />
                  {{ option.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "WidgetDetails",
  mixins: [clickaway],
  props: {
    widgetInfo: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: null
    },
    widgetOptions: {
      type: Array,
      default: () => []
    },
    tenant: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    actionButtons() {
      return this.widgetOptions.filter(option => {
        if (option.label === "Edit Details") return true;
        if (option.label === "Activate" && this.tenant.deletedAt) return true;
        if (option.label === "Deactivate" && !this.tenant.deletedAt)
          return true;
      });
    }
  },
  methods: {
    handleShowOptionsClick() {
      this.isVisible = !this.isVisible;
    },
    handleBodyClick() {
      this.isVisible = false;
    },
    customMethod(option) {
      if (option.method) {
        this.$emit(option.method);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-details {
  .block {
    background-color: $gray-50;
    box-shadow: none;
    &-header {
      h4 {
        border-bottom: 1px solid $gray-250;
        color: $gray-900;
        font-size: $font-size-xs;
        font-weight: 500;
      }
      .more-options-wrapper {
        border-radius: 50%;
        height: 30px;
        text-align: center;
        position: relative;
        width: 30px;
        img {
          position: relative;
          z-index: 2;
        }
        &:hover {
          &::before {
            transform: scale(1);
            z-index: 1;
          }
        }
        &::before {
          background-color: $gray-200;
          border-radius: 50%;
          content: "";
          cursor: pointer;
          height: 100%;
          left: 0;
          position: absolute;
          overflow: hidden;
          top: 0;
          transform: scale(0);
          transition: all 0.2s ease;
          width: 100%;
          z-index: -1;
        }
        .options {
          background-color: $white;
          border-radius: 5px;
          opacity: 0;
          position: absolute;
          right: 0;
          top: -10px;
          transition: all 0.2s ease-out;
          width: 200px;
          z-index: -1;
          &.is-visible {
            opacity: 1;
            top: 0;
            z-index: 1;
          }
          ul {
            margin: 25px 0 0;
            list-style-type: none;
            padding: 0;
            li {
              cursor: pointer;
              font-family: "Gotham Book";
              font-size: $font-size-xs;
              padding: 10px 0;
              transition: all 0.2s ease;
              &:hover {
                background-color: $gray-200;
              }
              a {
                align-items: center;
                color: $gray-900;
                display: flex;
                font-family: "Gotham Book";
                font-size: $font-size-xs;
                padding: 0 20px;
              }
              img {
                display: block;
                height: 12px;
                margin-right: 15px;
                width: 12px;
              }
              & > * {
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
